import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
  status: '',
  filteredMode: false,
};

const reportsSlice = createSlice({
  name: 'reportsUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setFilteredMode: (state, action) => {
      state.filteredMode = action.payload;
    },
    resetReportsFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, setStatus, setFilteredMode, resetReportsFilters } = reportsSlice.actions;
const pickupsReducer = reportsSlice.reducer;
export default pickupsReducer;
